import Card from '../../components/Card';
import EmptyState from '../../components/EmptyState';
import { Trash2 } from 'lucide-react';

export default function DeletedContent() {
    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-3xl font-bold mb-2">Deleted Content</h1>
                <p className="text-muted-light dark:text-muted-dark">
                    View and restore deleted posts and comments
                </p>
            </div>

            <Card>
                <EmptyState
                    icon={Trash2}
                    title="No deleted content"
                    description="Deleted posts and comments will appear here"
                />
            </Card>
        </div>
    );
}

